/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
      paper-card {
        height: fit-content !important;
        padding:24px 10% 10%;
      }
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
      .decline-text {
        font-size: 16px;
        font-weight: 700;
        color: #101214;
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="content-align-center">
      <div class="margin-b-zero mdl-cell mdl-cell--10-col">
        <paper-card>
          <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
            <div class="mdl-cell mdl-cell--12-col" style="padding-bottom: 10px"> 
                <div class="font-style font-30">
                    <oe-i18n-msg msgid="l_prereqdetails" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
            <div class="mdl-cell mdl-cell--12-col">
                <div class="font-style font-16 font-color">
                    <oe-i18n-msg msgid="l_confirmDetails" role="heading" aria-level="1"></oe-i18n-msg>
                </div>
            </div>
          </div>
          <template is="dom-if" if="{{showAccountsList}}">
            <div class="listing-table-container" style="border:2px solid #f6f8f9;border-radius: 5px;">
                <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
                    <div class="mdl-cell mdl-cell--12-col">
                        <div class="font-style font-24">
                            <oe-i18n-msg msgid="l_accountList" role="heading" aria-level="1"></oe-i18n-msg>
                        </div>
                    </div>
                </div>
                <div id="list-container" role="table">
                    <div class="content-align-vertical-center margin-b-zero mdl-grid horizontal layout font-10 secondary-color text-transform-uppercase font-weight-700" style="padding:1.2%;background-color:#FAFAFB;">   
                        <div class="mdl-cell mdl-cell--5-col">
                            <oe-i18n-msg class="acct-list-header-class" msgid="l_AccountName"></oe-i18n-msg>
                        </div>
                        <div class="mdl-cell mdl-cell--4-col">
                            <oe-i18n-msg class="acct-list-header-class" msgid="l_Account_Num"></oe-i18n-msg>
                        </div>
                        <div class="mdl-cell mdl-cell--3-col">
                            <oe-i18n-msg class="acct-list-header-class" msgid="l_Accounttype"></oe-i18n-msg>
                        </div>
                    </div>
                    <template is = "dom-repeat" items="{{displayRows}}">
                        <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px">
                            <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                                <div class="mdl-cell mdl-cell--5-col-desktop acct-list-value-class wrapClass1" role="cell">
                                    {{item.accountName}}
                                </div>
                                <div class="mdl-cell mdl-cell--4-col-desktop acct-list-value-class wrapClass1" role="cell">
                                    {{item.accountId}}
                                </div>
                                <div class="mdl-cell mdl-cell--3-col-desktop acct-list-value-class wrapClass1" role="cell">
                                    {{item.accountType.codeDescription}}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="pagination-margin">
                    <oe-data-table-custom-pagination rows-data="{{previewDetailsList}}" display-rows = "{{displayRows}}">
                    </oe-data-table-custom-pagination>
                </div>
            </div>
          </template>
          <template is="dom-if" if="{{!showAccountsList}}">
              <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px;border:2px solid #f6f8f9;border-radius: 5px;">
                  <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                      <div class="mdl-cell mdl-cell--12-col-desktop decline-text wrapClass1" role="cell">
                          {{getDeclineLabel()}}
                      </div>
                  </div>
              </div>
          </template>
          <div class="mdl-cell--12-col horizontal layout content-align-horizontal-end" tabindex="0" style="padding:4% 0px 10;">
            <div class="mdl-cell--3-col">
                <paper-button id="proceed" raised class="primary-medium-button" on-tap="callauthPage" style = "width:-webkit-fill-available;">
                    <oe-i18n-msg msgid="b_Submit"></oe-i18n-msg>
                </paper-button>
            </div>
          </div>
        </paper-card>
      </div>
    </div>
    `;
Polymer({
  is: 'open-banking-account-consents-preview',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow, sbBehaviours.paginationBehaviours],
  properties: {
    selectedPage: {
      type: String,
      notify: true
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    responseObject: {
      type: Object,
      notify: true,
      observer: "prepareDisplayList"
    },
    body: {
      type: Object,
      notify: true
    },
    authSuccess: {
      type: Boolean,
      notify: true,
      observer: '_setOchTxnId'
    },
    authSuccessObject: {
      type: Object,
      notify: true
    },
    previewDetails: {
      type: Object,
      notify: true
    },
    successResponse: {
      type: Array,
      notify: true
    },
    previewDetailsList: {
      type: Array,
      value: []
    },
    openBankingAccountsResponse: {
      type: Array,
      notify: true
    },
    successObj: {
      type: Object,
      notify: true
    },
    actionType: {
      type: String,
      notify: true,
      observer: "actionTypeChange"
    },
    showAccountsList: {
      type: Boolean,
      value: true
    },
    fromPreview: {
      type: Boolean,
      notify: true,
      value: false
    }
  },
  formatDate: function (date) {
    return moment.utc(date).format('DD-MMM-YYYY');
  },
  _proceedToSuccessConsent() {
    this.userremarks = this.previewDetails.approverComment;
    var headervalue = {};
    if (this.previewDetails.displayAuthorization) {
      if (this.authenticationValidation(this.previewDetails.authMethods)) return;
      if (this.previewDetails.authMethods && this.previewDetails.authMethods.length == 1) {
        headervalue.primaryAccessCode = this.previewDetails.authMethods[0].wrapperValue;
      }
      if (this.previewDetails.authMethods && this.previewDetails.authMethods.length == 2) {
        headervalue.primaryAccessCode = this.previewDetails.authMethods[0].wrapperValue;
        headervalue.secondaryAccessCode = this.previewDetails.authMethods[1].wrapperValue;
      }
    }
    if (this.authSuccessObject != undefined) {
      headervalue.ochTransactionId = this.authSuccessObject.ochTransactionId;
      headervalue.authorizationMode = this.authSuccessObject.authorizationMode;
      if (this.authSuccessObject.softtokenotp) {
        headervalue.primaryAccessCode = this.authSuccessObject.softtokenotp;
      }
    }
    headervalue.acceptTermsAndConditions = 'Y';
    headervalue.workflowInput = {
      userRemarks: this.userremarks
    };
    var url = "/api/CBUsers/" + this.userId + "/customopenbanking-consent-request";
    var method = "POST";
    var transactionType = "OPC";
    var channelContextVal = undefined;
    this.submitNonFinancialDetails(url, method, this.body, headervalue, transactionType, channelContextVal);
  },
  prepareDisplayList() {
    if (this.responseObject && this.openBankingAccountsResponse) {
      var responseList = [];
      var self = this;
      if (self.responseObject.accountIdList && self.responseObject.accountIdList.length > 0) {
        this.openBankingAccountsResponse.forEach(item => {
          self.responseObject.accountIdList.forEach(element => {
            if (item.accountId == element.accountId) {
              if (element.accountType.cmCode == "CCD" || element.accountType.cmCode == "PCD") {
                element.accountId = this._formatCreditCard(element.accountId);
              }
              element.accountType = item.accountType;
              element.accountName = item.accountName;
              element.accountNickName = item.accountNickName;
              responseList.push(element);
            }
          });
        });
      }
      this.previewDetailsList = responseList;
    }
  },
  _callSucessPage(event) {
    var tempSuccessObj = event;
    this.successResponse = event.detail.response;
    var responseHeader = JSON.parse(event.detail.xhr.getResponseHeader('channelcontext'));
    tempSuccessObj.chennelContext = responseHeader;
    this.successObj = tempSuccessObj;
    this.detailsTabEnabled = false;
    this.selectedPage = 3;
    this.authSuccess = false;
  },
  callauthPage() {
    this.selectedPage = 2;
    this.fromPreview = true;
  },
  _setOchTxnId() {
    if (this.authSuccess == true) {
      this._proceedToSuccessConsent();
    }
  },
  actionTypeChange() {
    if (this.actionType && this.actionType == "APPROVE") {
      this.showAccountsList = true;
    }
    else {
      this.showAccountsList = false;
    }
  },
  getDeclineLabel() {
    return getLabel("l_declineAccountConsentText");
  },
  _errorHandler(event) {
    showAjaxError(event);
    var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
    var headers = convertedArr.reduce(function (each, current, i) {
      var parts = current.split(': ');
      each[parts[0]] = parts.slice(1).join();
      return each;
    }, {});
    if (headers.channelcontext) {
      var messageToDisplay = "";
      var channelcontext = JSON.parse(headers.channelcontext);
      var msgList = [];
      if (channelcontext.status.message && channelcontext.status.message.length > 1) {
        for (i = 0; i < channelcontext.status.message.length; i++) {
          msgList.push(channelcontext.status.message[i].messageDesc);
        }
        messageToDisplay = msgList[0];
      }
      else if (channelcontext.status.message) {
        messageToDisplay = channelcontext.status.message[0].messageDesc;
      }
    }
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        var redirectUrl = clientStorage.get(storageType.session, 'backendRedirectUri') + "?status=FAL" + "&state=" + clientStorage.get(storageType.session, 'openBankingState') + "&event=" + messageToDisplay;
        window.location.href = redirectUrl;
      }
    }, 5000);
  }
});
